<div class="card">
  <div class="card-header bg-warning text-dark d-flex justify-content-between align-items-center">
    <h5 class="mb-0"><i class="fas fa-file-contract"></i> Texto Legal de Liquidaciones</h5>
    <button class="btn btn-sm"
            [class.btn-success]="activo"
            [class.btn-secondary]="!activo"
            (click)="toggleActivo()"
            [disabled]="loading">
      <i class="fas" [class.fa-eye]="activo" [class.fa-eye-slash]="!activo"></i>
      {{ activo ? 'Activo' : 'Desactivado' }}
    </button>
  </div>
  <div class="card-body">

    <div *ngIf="loading" class="text-center py-4">
      <p class="text-muted">Cargando...</p>
    </div>

    <div *ngIf="!loading">

      <div class="form-group">
        <label><strong>Párrafo 1 — Texto antes de los días</strong></label>
        <small class="form-text text-muted mb-1">Termina justo antes del campo numérico de días.</small>
        <textarea class="form-control"
                  rows="3"
                  [(ngModel)]="textos.texto_legal_p1_pre">
        </textarea>
        <button class="btn btn-link btn-sm p-0 mt-1" (click)="restaurarDefecto('texto_legal_p1_pre')">
          Restaurar texto original
        </button>
      </div>

      <div class="form-group">
        <label><strong>Párrafo 1 — Texto después de los días</strong></label>
        <small class="form-text text-muted mb-1">Va después del campo de días en letras. Por defecto: " días."</small>
        <input type="text"
               class="form-control"
               [(ngModel)]="textos.texto_legal_p1_post">
        <button class="btn btn-link btn-sm p-0 mt-1" (click)="restaurarDefecto('texto_legal_p1_post')">
          Restaurar texto original
        </button>
      </div>

      <div class="form-group">
        <label><strong>Párrafo 2 — Texto en formato normal</strong></label>
        <small class="form-text text-muted mb-1">Texto antes de la parte en negrita.</small>
        <textarea class="form-control"
                  rows="4"
                  [(ngModel)]="textos.texto_legal_p2_normal">
        </textarea>
        <button class="btn btn-link btn-sm p-0 mt-1" (click)="restaurarDefecto('texto_legal_p2_normal')">
          Restaurar texto original
        </button>
      </div>

      <div class="form-group">
        <label><strong>Párrafo 2 — Texto en negrita</strong></label>
        <small class="form-text text-muted mb-1">Este texto aparece en negrita en el documento.</small>
        <textarea class="form-control"
                  rows="2"
                  [(ngModel)]="textos.texto_legal_p2_negrita">
        </textarea>
        <button class="btn btn-link btn-sm p-0 mt-1" (click)="restaurarDefecto('texto_legal_p2_negrita')">
          Restaurar texto original
        </button>
      </div>

      <!-- Vista previa -->
      <div class="card bg-light mt-3 mb-3">
        <div class="card-header">
          <strong>Vista previa</strong>
        </div>
        <div class="card-body preview-texto-legal">
          <p>
            {{textos.texto_legal_p1_pre}}<span class="badge badge-secondary">[días nro]</span>
            (<span class="badge badge-secondary">[días letras]</span>){{textos.texto_legal_p1_post}}
          </p>
          <p>
            {{textos.texto_legal_p2_normal}}<strong>{{textos.texto_legal_p2_negrita}}</strong>
          </p>
        </div>
      </div>

      <div class="text-right">
        <button class="btn btn-primary"
                (click)="guardarTodo()"
                [disabled]="guardando">
          <span *ngIf="guardando">Guardando...</span>
          <span *ngIf="!guardando"><i class="fas fa-save"></i> Guardar texto legal</span>
        </button>
      </div>

    </div>
  </div>
</div>
